<app-initialization-loading-indicator [failed]="initFailed"
                                      [loading]="!isInitialized"></app-initialization-loading-indicator>

@if (isInitialized && applicationStateService.bookConfig) {
    <div (keydown)="onKeyDown($event)"
         (wheel)="onScroll($event)"
         (window:mouseup)="onMouseUp()"
         (window:touchend)="onMouseUp()"
         class="bookviewer-container"
         tabindex="-1"
    >
        <div class="visually-hidden">
            Tastaturkürzel sind verfügbar. Drücken Sie Option + H (Mac) bzw. Alt + H (Windows/Linux) oder die Umschalt- und Fragezeichentaste, um das Hilfefenster für alle Tastenkombinationen zu öffnen.
        </div>
        <div class="bookviewer-skip-links">
            <a href="#" (click)="accessibilityService.toggleHelpModal()" class="skip-link">Tastenkombinationen anzeigen</a>
            <a href="#pageContentWrapper" (click)="skipTo($event, 'pageContentWrapper')" class="skip-link">Zum Inhalt springen</a>
        </div>
        <div [class.blurred]="helpService.helpOpened"
             [class.rect-mode]="applicationStateService?.pageEditMode?.constructor.name === rectPageEditModeClassName"
             [class.text-mode]="applicationStateService?.pageEditMode?.constructor.name === selectionPageEditModeClassName || applicationStateService?.pageEditMode?.constructor.name === copyPageEditModeClassName"
             class="bookviewer">
            @if (applicationStateService.currentViewMode.showTopbar) {
                <app-topbar></app-topbar>
            }
            <div [class.expanded]="!applicationStateService.isSidebarHidden"
                 [style.width.px]="sidebarConfig.sidebarMinimizedWidth"
                 id="sidebarWrapper">
                <app-sidebar></app-sidebar>
            </div>
            <div id="wrapper">
                <div (pinchin)="onPinchIn($event)"
                     (pinchout)="onPinchOut($event)"
                     [class.expanded]="!applicationStateService.isSidebarHidden"
                     id="pageContentWrapper">
                    <app-pages></app-pages>
                </div>
            </div>
            @if (applicationStateService.bookConfig.productLink || applicationStateService.bookConfig.storeLink) {
                <app-buy-book></app-buy-book>
            }
            <div id="toolBarWrapper">
                <app-tools-bar></app-tools-bar>
            </div>
        </div>
        <app-copy-hud></app-copy-hud>
        <app-copy-text-hud></app-copy-text-hud>
        @if (showEdividualIFrame) {
            <iframe [src]="edividualSrc | safeHtml: 'resourceUrl'" height="1" width="1"></iframe>
        }
    </div>
}
